import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import {
  apiGetUser,
} from "../../services/UserService";
import {
  apiUpdateWorkspace,
  apiLeaveWorkspace,
  // apiGetWorkspaceMembers,
} from "../../services/WorkspaceService";
import { toastFail, toastSuccess } from "../../config";
import { useSelector, useDispatch } from "react-redux";
import { setUser, selectUser } from "../../redux/features/appData/appDataSlice";
import { useNavigate, useLocation } from "react-router-dom";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import { postImage } from "../../services/client";
import MemberManager from "./MemberManager";
import "./Workspaces.css";
import { useAuth } from "../../hooks/useAuth";
import Modal from "../shared/Modal";
import ModalDeleteWorkspace from "./ModalDeleteWorkspace";
import { useCoreDataLoader } from "../../hooks/useCoreDataLoader";

const TABS_NUMBERS = {
  BASICS: "1",
  CONNECT: "2",
  TEAM: "3",
  MUTED: "4",
};

const pickerOptions = {
  // DropdownIndicator: false,
  // Input: false,
  IndicatorSeparator: () => null,
};

export default function Workspaces() {
  const auth = useAuth();
  const storeUser = useSelector(selectUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { reloadAll } = useCoreDataLoader();

  const [currentWorkspace, setCurrentWorkspace] = useState(null);
  const [changed, setChanged] = useState(false);

  const [logoFile, setLogoFile] = useState("");
  const logoFileRef = useRef();

  const [leaveDialogOpen, setLeaveDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const [tabNumber, setTabNumber] = useState(TABS_NUMBERS.BASICS);

  useEffect(() => {
    auth.checkStatus();

    // if we have a tab in query string use it
    const queryParams = new URLSearchParams(location.search);
    if (queryParams) {
      const tab = queryParams.get("tab");
      if (tab) {
        console.log("[Workspace] setting tab: ", tab);
        setTabNumber(tab);
      }
    }
  }, []);

  useEffect(() => {
    if (!storeUser) {
      return;
    }

    // if not all that stuff, then just grab the right workspace
    let index = storeUser.workspaces.findIndex(
      (workspace) => workspace.id === storeUser.currentWorkspaceId
    );

    if (index === -1) {
      console.error(
        "[workspaces/useEffect] can't get current workspace, defaulting to 0th"
      );
      index = 0;
    }

    setCurrentWorkspace({ ...storeUser.workspaces[index] });
  }, [storeUser]);

  // useEffect(() => {
  //   (async () => {
  //     if (storeUser?.currentWorkspaceId) {
  //       const finalMembers = await apiGetWorkspaceMembers(
  //         storeUser.currentWorkspaceId
  //       );

  //       if (finalMembers) {
  //         finalMembers.sort((a, b) => {
  //           const aText = a.firstName ?? a.lastName ?? "";
  //           const bText = b.firstName ?? b.lastName ?? "";
  //           return aText.toLowerCase().localeCompare(bText.toLowerCase());
  //         });

  //         const options = finalMembers.map((member) => {
  //           return {
  //             label: member.firstName + " " + member.lastName,
  //             value: member.id,
  //           };
  //         });

  //         options.unshift({
  //           label: "(none configured)",
  //           value: "",
  //         });

  //       }
  //     }
  //   })();
  // }, [storeUser]);

  useEffect(() => {
    if (currentWorkspace) {
      // console.log("[workspaces/useEffect] here");
      const workspaceId = currentWorkspace.id;
    }
  }, [currentWorkspace]);

  const leaveWorkplace = async () => {
    const result = await apiLeaveWorkspace(currentWorkspace.id, storeUser.id);
    if (result) {
      dispatch(setUser(result));
      toast("Removed from workspace", toastSuccess);
      navigate("/");
      return;
    }
  };

  const handleWorkspaceName = (e) => {
    setCurrentWorkspace({ ...currentWorkspace, name: e.target.value });
    setChanged(true);
  };

  const updateWorkspaceName = async () => {
    await apiUpdateWorkspace(currentWorkspace);
    const updatedUser = await apiGetUser(storeUser.id);
    dispatch(setUser(updatedUser));
    toast("Workspace updated.", toastSuccess);
  };

  const changeTab = (e, newValue) => {
    setTabNumber(newValue);
  };

  const changeLogo = () => {
    if (logoFileRef?.current) {
      const inputButton = logoFileRef.current;
      setLogoFile("");
      inputButton.click();
    }
  };

  const handleFileChange = (event) => {
    if (!storeUser) {
      return;
    }

    if (event.target.files && event.target.files?.length < 1) {
      // console.log("[Workspaces/handleFileChange] user cancelled picking a file");
      return;
    }

    if (event.target.files && event.target.files[0].size > 10485760) {
      toast("Logo is too big! Please keep it under 10MB", toastFail);
      return;
    }

    const theFile = event.target.files ? event.target.files[0] : null;

    if (!theFile) {
      toast("Did not get a valid file", toastFail);
      return;
    }

    // console.log("[Workspaces/handleFileChange] uploading file: " + theFile.name);

    (async () => {
      toast("Uploading...", toastSuccess);

      try {
        const response = await postImage(storeUser.id, theFile, null);

        if (response.status === 200) {
          const theWorkspace = {
            ...currentWorkspace,
            image: response.data.data,
          };
          setCurrentWorkspace(theWorkspace);
          await apiUpdateWorkspace(theWorkspace);

          // update the sidebar
          const apiUser = await apiGetUser(storeUser.id);

          if (!apiUser) {
            console.error(
              "[Workspaces/handleFileChange] error refreshing user!"
            );
            return;
          }

          dispatch(setUser(apiUser));
        } else {
          toast("File not uploaded: " + response.status, toastFail);
        }
      } catch (error) {
        // Handle error
        console.error("Error uploading file:", error);
        toast("Error uploading file, please try again.", toastFail);
      }
    })();
  };

  // console.log("[workspaces/mainflow] storeUser: ", storeUser);
  // console.log("[Workspaces/main] currentWorkspace: ", currentWorkspace);
  // console.log("[Workspaces/main] storeUser: ", storeUser);

  return (
    <>
      {currentWorkspace && (
        <div id="workspaces">
          <div className="page-title">
            Workspace Settings
          </div>

          <div className="workspaces-body">
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={tabNumber}>
                <Box sx={{}}>
                  <TabList
                    onChange={changeTab}
                    aria-label="lab API tabs example"
                    sx={{
                      "&.MuiTabPanel": { padding: "0px" },
                    }}
                    TabIndicatorProps={{
                      style: { background: "var(--text-color-primary)" },
                    }}>
                    <Tab
                      sx={{
                        "&.Mui-selected": {
                          color: "var(--text-color-primary)",
                        },
                        color: "var(--text-color-secondary)",
                      }}
                      label="Basic Details"
                      value="1"
                    />

                    <Tab
                      sx={{
                        "&.Mui-selected": {
                          color: "var(--text-color-primary)",
                        },
                        color: "var(--text-color-secondary)",
                      }}
                      label="Members"
                      value="3"
                    />

                  </TabList>
                </Box>

                <TabPanel value="1">
                  <div className="workspaces-container">
                    <div className="workspaces-header">
                      <h2>Workspace Name</h2>
                      <span style={{ color: "var(--text-color-secondary)" }}>
                        Update the name of your workspace that appears on the
                        sidebar.
                      </span>
                    </div>

                    <div className="workspaces-name">
                      <input
                        type="text"
                        value={currentWorkspace.name}
                        onChange={handleWorkspaceName}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            updateWorkspaceName();
                          }
                        }}
                      />
                      <button
                        id="save-button"
                        type="button"
                        onClick={updateWorkspaceName}
                        disabled={!changed}>
                        Save
                      </button>
                    </div>

                    {/* <div className="workspaces-divider"></div> */}

                    {/* <div className="workspaces-icon">
                      <div className="workspaces-header">
                        <div className="workspaces-title">
                          <h2>Update Workspace Icon</h2>
                        </div>
                        <span style={{ color: "var(--text-color-secondary)" }}>
                          Change the image for your workspace that appears on
                          the sidebar.
                        </span>
                      </div>
                    </div>

                    <div className="workspaces-logo-section">
                      <div className="workspaces-logo">
                        <input
                          type="file"
                          accept="image/png, image/jpeg, image/jpg, image/gif"
                          ref={logoFileRef}
                          style={{ display: "none" }}
                          value={logoFile}
                          onChange={handleFileChange}
                          onError={(event) => console.log("onError", event)}
                        />
                        <img src={currentWorkspace.image}></img>
                        <button onClick={changeLogo}>Upload a Photo</button>
                      </div>
                    </div> */}

                    {/* Leave workspace section */}
                    {/* Maybe add a confirm dialog? */}
                    {/* {storeUser.id !== currentWorkspace?.ownerId && (
                      <div className="workspaces-header">
                        <div className="leave-workspace-container">
                          <div className="workspaces-title">
                            <h2>Leave Workspace</h2>
                          </div>
                          <div className="leave-button-container">
                            <button
                              className="leave-button"
                              onClick={() => setLeaveDialogOpen(true)}>
                              Leave Workspace
                            </button>
                          </div>
                        </div>
                      </div>
                    )} */}

                    {/* delete a workspace if you're the owner */}
                    {storeUser.id === currentWorkspace?.ownerId && (
                      <div className="workspaces-header">
                        <div className="delete-workspace-container">
                          <div className="workspaces-title">
                            <h2>Delete Workspace</h2>
                          </div>
                          <span
                            style={{ color: "var(--text-color-secondary)" }}>
                            Delete your workspace and all contents used for
                            answering questions.
                          </span>
                          <div className="delete-button-container">
                            <button
                              className="button-save"
                              onClick={() => setDeleteDialogOpen(true)}>
                              Delete Workspace
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </TabPanel>

                <TabPanel value="3">
                  <MemberManager />
                </TabPanel>

              </TabContext>
            </Box>
          </div>

          <Modal
            isOpen={leaveDialogOpen}
            style={null}
            onClose={() => {
              setLeaveDialogOpen(false);
            }}>
            <div className="shares-card-delete-container">
              <div className="shares-card-delete-title">
                <h2>Delete?</h2>
                <span style={{ color: "var(--text-color-secondary)" }}>
                  Are you sure you want to leave this workspace?
                </span>
              </div>
              <div className="modal-buttons">
                <button
                  className="button-cancel"
                  onClick={() => {
                    setLeaveDialogOpen(false);
                  }}>
                  Cancel
                </button>
                <button
                  onClick={leaveWorkplace}
                  className="shares-card-delete-buttons-delete">
                  Yes, Delete
                </button>
              </div>
            </div>
          </Modal>

          {deleteDialogOpen && (
            <ModalDeleteWorkspace
              isOpen={deleteDialogOpen}
              onClose={() => {
                setDeleteDialogOpen(false);
              }}
              workspaceId={storeUser.currentWorkspaceId}
            />
          )}
        </div>
      )}
    </>
  );
}
